module.exports = __webpack_public_path__ + "img/avatar_15.16ab8dd8.svg";